import React, { Component } from "react";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import Hidden from "@mui/material/Hidden";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import withStyles from '@mui/styles/withStyles';
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import FolderSpecialOutlinedIcon from "@mui/icons-material/FolderSpecialOutlined";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import { Colors } from "config/StyleConfig";
import { NavLink } from "react-router-dom";
import { pageRoutes, getCurrentRoute } from "Routes";
import { connect } from "react-redux";
import { toggleMobileOpen } from "./MenuAction";
import TokenManager from "storage/TokenManager";
import Config from "config/Config";
import Typography from "@mui/material/Typography";

export const DRAWER_WIDTH = 240;

const styles = (theme) => ({
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
    },
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: DRAWER_WIDTH,
    background: Colors.drawer,
  },
  listItem: {
    color: Colors.drawerItems,
    "&.Mui-selected": {
      backgroundColor: Colors.selectedDrawerItems,
    },
  },
  versionTypography: {
    color: Colors.versionColor,
  },
});

class SideDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      selection: 0,
    };
  }

  generateListITem(classes, to, index, Icon, text, authorized) {
    if (!authorized) {
      return <div />;
    }

    return (
      <NavLink to={to} style={{ textDecoration: "none" }}>
        <ListItem button onClick={() => this.setState({ selection: index })} className={classes.listItem} selected={getCurrentRoute() === to}>
          <ListItemIcon className={classes.listItem}>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
      </NavLink>
    );
  }

  render() {
    const { classes } = this.props;

    const getList = () => {
      return (
        <List>
          {this.generateListITem(
            classes,
            pageRoutes.analytics.path,
            0,
            AssessmentOutlinedIcon,
            "Analytics",
            pageRoutes.analytics.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.inspections.path,
            0,
            AssignmentOutlinedIcon,
            "Inspections",
            pageRoutes.inspections.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.overview.path,
            1,
            AssessmentOutlinedIcon,
            "Overview",
            pageRoutes.overview.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.projects.path,
            1,
            FolderSpecialOutlinedIcon,
            "Projects",
            pageRoutes.projects.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.clients.path,
            1,
            BusinessIcon,
            "Clients",
            pageRoutes.clients.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.preferences.path,
            1,
            EqualizerOutlinedIcon,
            "Preferences",
            pageRoutes.preferences.authorized.includes(TokenManager.getUserType())
          )}
          {this.generateListITem(
            classes,
            pageRoutes.users.path,
            1,
            SupervisorAccountOutlinedIcon,
            "Users",
            pageRoutes.users.authorized.includes(TokenManager.getUserType())
          )}
        </List>
      );
    };

    const drawer = (
      <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", flex: 1 }}>
        <div>
          <div className={classes.toolbar}>
            <img alt="Company logo" style={{ width: "60%", height: "auto", margin: "30px auto 5px auto", display: "block", objectFit: "contain", WebkitFilter: "grayscale(100%) brightness(300%)"}} draggable={false} src={TokenManager.getCompanyLogo()}/>
          </div>
          <Divider />
          {getList()}
        </div>
        <Typography className={classes.versionTypography} style={{ marginBottom: 10, textAlign: "center" }}>
          {Config.VERSION}
        </Typography>
      </div>
    );

    return (
      <nav className={classes.drawer}>
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={this.props.container}
            variant="temporary"
            open={this.props.mobileOpen}
            onClose={() => this.props.toggleMobileOpen()}
            classes={{ paper: classes.drawerPaper }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMobileOpen: () => dispatch(toggleMobileOpen()),
  };
};

const mapStateToProps = (state) => {
  return {
    mobileOpen: state.MenuReducer.mobileOpen,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SideDrawer));
